/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Body2Inputs */

const en_diff_body2 = /** @type {(inputs: Diff_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every difference is reported as a path plus a marker: a plus for a key or index present only on the right, a minus for one present only on the left, and a tilde for a path that exists on both sides with different values. Paths use dots for object keys and square brackets for array indices, so you can paste one straight into your code to reach the value it names.`)
};

const ko_diff_body2 = /** @type {(inputs: Diff_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 차이는 경로와 표식으로 보고됩니다. 더하기는 오른쪽에만 있는 키나 인덱스, 빼기는 왼쪽에만 있는 것, 물결표는 양쪽에 있지만 값이 다른 경로입니다. 경로는 객체 키에 점을, 배열 인덱스에 대괄호를 쓰므로, 하나를 그대로 코드에 붙여넣어 그 값에 접근할 수 있습니다.`)
};

const ja_diff_body2 = /** @type {(inputs: Diff_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての差分はパスと記号で報告されます。プラスは右側にだけあるキーまたは添字、マイナスは左側にだけあるもの、チルダは両側にあって値が異なるパスです。パスはオブジェクトキーにドット、配列添字に角かっこを使うので、1 つをそのままコードに貼り付けてその値に到達できます。`)
};

/**
* | output |
* | --- |
* | "Every difference is reported as a path plus a marker: a plus for a key or index present only on the right, a minus for one present only on the left, and a ti..." |
*
* @param {Diff_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_body2 = /** @type {((inputs?: Diff_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_body2(inputs)
	if (locale === "ko") return ko_diff_body2(inputs)
	return ja_diff_body2(inputs)
});